/**
 * Garden Column Mapping
 * Garden uses semantic field names directly (no col1, col2 mapping needed)
 * This file provides a reverse mapping for dimension values
 */

/**
 * Identity mapping: field name to itself
 * Used for mapping dimension values to their field names
 */
export const GARDEN_REVERSE_MAPPING: { [fieldName: string]: string } = {
  // Base measurements
  'scaffoldPlatform': 'scaffoldPlatform',
  'geotextileLayer': 'geotextileLayer',
  'harrowGardens': 'harrowGardens',
  'plotClearance': 'plotClearance',

  // Dynamic fields
  'thickNoDigLayer': 'thickNoDigLayer',
  'spreadLevelCleanSubsoilCapSiteWon': 'spreadLevelCleanSubsoilCapSiteWon',
  'spreadLevelCleanSubsoilCapImported': 'spreadLevelCleanSubsoilCapImported',
  'spreadLevelTopsoilSiteWon': 'spreadLevelTopsoilSiteWon',
  'spreadLevelTopsoilImported': 'spreadLevelTopsoilImported',
};
